
<template>

  <div class="frame" :style="{'height': $store.state.activeRoom.info ? '500px' : '600px'}">
    <div :class="flipClass">
      <div class="card card-front">
        <front-component v-on:initFlip="flipTo($event)" :rm="room" :status="status" :refsh="refreshing" v-show="front === 'front' && showFront"></front-component>
        <left-component v-on:initFlip="flipTo($event)" :room="room" :status="status" v-if="front === 'left' && showFront"></left-component>
        <right-component v-on:initFlip="flipTo($event)" :room="room" :status="status" v-if="front === 'right' && showFront"></right-component>
        <settings-component v-on:initFlip="flipTo($event)" v-on:setRefresh="refreshCard($event)" :room="room" v-if="front === 'settings' && showFront"></settings-component>
        <setpoints-component v-on:initFlip="flipTo($event)" v-on:setRefresh="refreshCard($event)" :room="room" v-if="front === 'setpoints' && showFront"></setpoints-component>
        <spider-component v-on:initFlip="flipTo($event)" :room="room" :status="status" v-if="front === 'spider' && showFront"></spider-component>
        <!-- <spider-component v-on:initFlip="flipTo($event)" :index="index" v-show="front === 'spider' && showFront"></spider-component> -->
      </div>
      <div class="card card-back">
        <front-component v-on:initFlip="flipTo($event)" :rm="room" :status="status" :refsh="refreshing" v-show="back === 'front' && !showFront"></front-component>
        <left-component v-on:initFlip="flipTo($event)" :room="room" :status="status" v-if="back === 'left' && !showFront"></left-component>
        <right-component v-on:initFlip="flipTo($event)" :room="room" :status="status" v-if="back === 'right' && !showFront"></right-component>
        <settings-component v-on:initFlip="flipTo($event)" v-on:setRefresh="refreshCard($event)" :room="room" v-if="back === 'settings' && !showFront"></settings-component>
        <setpoints-component v-on:initFlip="flipTo($event)" v-on:setRefresh="refreshCard($event)" :room="room" v-if="back === 'setpoints' && !showFront"></setpoints-component>
        <spider-component v-on:initFlip="flipTo($event)" :room="room" :status="status" v-if="back === 'spider' && !showFront"></spider-component>
        <!-- <spider-component v-on:initFlip="flipTo($event)" :index="index" v-show="front === 'spider' && showBack"></spider-component> -->
      </div>
    </div>
  </div>

</template>
s
<script>

import { mapState } from 'vuex';

import Front from './Front';
import Left from './Left';
import Right from './Right';
import Settings from './Settings';
import Toggle from './Toggle';
import Setpoints from '@/components/setpoints/Setpoints';
import Spider from './Spider';

export default {

  data(){
    return {
      flipClass: 'frame-inner',
      showFront: true,
      showBack: false,
      front: 'front',
      back: 'right',
      foundIndex: -1,
      refreshing: false,
      status: {}
    }
  },

  props: ['room'],

  components: {
    'front-component': Front,
    'left-component': Left,
    'right-component': Right,
    'settings-component': Settings,
    'toggle-component': Toggle,
    'setpoints-component': Setpoints,
    'spider-component': Spider
  },

  computed: {
    // getStatus(){
    //   return this.$store.getters.getStatusOfRoom(this.room.did);
    // }
  },

  methods: {

    refreshCard(){
      this.refreshing = this.refreshing ? false : true;
      const front = this.front;
      const back = this.back;
      this.front = '';
      this.back = '';
      this.status = this.$store.getters.getStatusOfRoom(this.room.did);
      this.front = front;
      this.back = back;
    },

    flipTo(dir){
      if (this.flipClass === 'frame-inner') {
        this.front = dir.from;
        this.back = dir.to;
        this.flipClass = 'frame-inner flipped-inner';
        setTimeout(() => this.showFront = false, 200);
      } else {
        this.back = dir.from;
        this.front = dir.to;
        this.flipClass = 'frame-inner';
        setTimeout(() => this.showFront = true, 200);
      }
    },

  },

  mounted(){
    if (Math.round(Date.now()/1000) >= this.$store.state.sessionEnd) {
      this.$store.dispatch('logoutNotif');
      this.$router.push({path: '/'});
    }
    this.$store.state.activeRoom = {};
    this.status = this.$store.getters.getStatusOfRoom(this.room.did);
  }

}

</script>

<style>

.frame {
  background-color: transparent;
  width: 350px;
  max-width: 100vw;
  min-height: 525px;
  max-height: calc(100vh - 190px);
  perspective: 1000px;
  border-radius: 8px;
}

.frame-inner {
  position: relative;
  width: 100%;
  height: 100%;
  transition: transform .7s;
  transform-style: preserve-3d;
  transform-origin: center;
  display: flex;
  justify-content: center;
  align-items: center;
}

.flipped-inner {
  transform: rotateY(180deg);
}

.card-front, .card-back {
  width: 100%;
  height: 100%;
  position: absolute;
  backface-visibility: hidden;
  margin: 0px;
  border-radius: 8px;
}

.card-back {
  transform: rotateY(-180deg);
}

.status {
  height: 7px;
  border-top-left-radius: 1px;
  border-top-right-radius: 1px;
}

.full-status {
  width: 100%;
}

.card-header {
  background: transparent;
  height: auto;
  border-bottom: none;
  position: relative;
}

.card-title {
  width: 75%;
  height: 100px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  margin-left: 10px;
}

.card-title h3 {
  color: rgb(0, 153, 191);
  font-weight: lighter;
  margin: 4px;
}

.card-title h6 {
  margin: 4px;
  margin-left: 6px;
  font-size: .75em;
}

.card-body {
  width: 100%;
  height: 65%;
  padding-top: 5%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
}

.side-body {
  height: 100%;
  padding-top: 10px;
  margin: 0px;
  justify-content: flex-start;
}

.card-info {
  height: 42.5%;
  width: 90%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgb(2, 27, 47);
  border: 1px solid gray;
  position: relative;
  overflow: hidden;
}

.double-info {
  height: 60.5%;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  border: 1px solid gray;
  overflow: hidden;
}

.maint-header {
  width: 100%;
  height: 15%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.maint-node {
  width: 50%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #556e84;
}

.maint-node h5 {
  padding: 0px;
  margin: 11px;
}

.active-maint-node {
  height: 15%;
  background-color: rgb(2, 27, 47);
}

.active-maint-node h5 {
  color: rgb(0, 153, 191);
}

.alert-node {
  width: 80%;
  height: 45px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: transparent;
  margin: 3px;
}

.maint-body {
  width: 100%;
  height: 80%;
  margin-top: 6%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  overflow-x: hidden;
  overflow-y: scroll;
}

.alert-head {
  width: 35%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.alert-head img {
  height: 70%;
}

.alert-node h5 {
  font-size: .75em;
  width: 65%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.right-status {
  width: 25%;
  display: flex;
  align-self: flex-end;
}

.card-head-sep {
  width: 80%;
  border: 1px solid gray;
  margin-left: 10%;
}

</style>



// WEBPACK FOOTER //
// src/components/card/Frame.vue